import { render, staticRenderFns } from "./WidgetMobileControls.vue?vue&type=template&id=2d1824fe"
import script from "./WidgetMobileControls.vue?vue&type=script&lang=js"
export * from "./WidgetMobileControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports